module.exports = __webpack_public_path__ + "static/media/mediacapital.b629fdf7.webp";